function Line({ title, ...args }) {
  return (
    <div className="textline flex">
      <p className="title">{title}: </p>
      {typeof args.content === "string" ? <p>{args.content}</p> : args.content}
    </div>
  );
}

export default Line;
